<template>
  <div class="">
    <el-container>
      <el-main>
        <el-button size="small" style="margin-right: 8px" type="warning" icon="el-icon-plus" @click="openOff">新增问题</el-button>
        <el-button size="small" @click="loadList(1)" type="primary" icon="el-icon-search">搜索</el-button>
        <el-table :data="tableData" border :row-style="{height:'40px',textAlign:'center'}" :max-height="maxHeight" :cell-style="{height:'5px,0',textAlign:'center'}" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" style="width: 100%;margin-top: 1%">
          <el-table-column type="selection">
          </el-table-column>
          <el-table-column prop="id" label="ID">
          </el-table-column>
          <el-table-column prop="title" label="标题">
          </el-table-column>
          <el-table-column prop="content" label="内容" width="300">
          </el-table-column>
          <el-table-column prop="createUser" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-delete" size="mini" @click="editProblem(scope.row.id)">编辑问题</el-button>

              <el-button type="primary" icon="el-icon-search" size="mini" @click="deleteProblem(scope.row.id)">删除问题</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="loadList" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
    <el-dialog title="新增问题" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="class_dialog_hospital" width="40%">
      <div class="msg">
        <span>请输入问题的标题：</span>
        <div style="margin-top:10px;">
          <el-input v-model.trim="title" placeholder="请输入标题"></el-input>
        </div>
        <div class="q-my-sm">
          <!--<editor v-model="content"></editor>-->
          <el-input type="textarea" v-model.trim="content" placeholder="请输入内容" :rows="14">
          </el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle">取 消</el-button>
        <el-button size="small" type="primary" @click="addProblem()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="问题编辑" :close-on-click-modal="false" :visible.sync="dialogProblem" class="class_dialog_hospital" width="40%">
      <el-form ref="problemInfo" :model="problemInfo">
        <div class="msg">
          <span>请输入问题的标题：</span>
          <div style="margin-top:10px;">
            <el-input v-model.trim="problemInfo.title" placeholder="请输入标题"></el-input>
          </div>
          <div class="q-my-sm">
            <!--<editor v-model="problemInfo.content"></editor>-->
            <el-input type="textarea" v-model.trim="problemInfo.content" :rows="14" placeholder="">

            </el-input>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editCancle">取 消</el-button>
        <el-button size="small" type="primary" @click="editProblemd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import Pagination from '../../../components/pagination'
import editor from '../../../utils/edit.vue'
export default {
  name: 'menu_list',
  components: { Pagination, editor },
  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.loadList(1)
  },
  data() {
    return {
      maxHeight: 500,
      tableData: [],
      title: '',
      content: '',
      dialogFormVisible: false,
      dialogProblem: false,
      problemInfo: {}
    }
  },
  methods: {
    //新增问题
    openOff() {
      let _this = this
      ;(_this.title = ''), (_this.content = ''), (_this.dialogFormVisible = true)
    },
    cancle() {
      let _this = this
      _this.dialogFormVisible = false
      _this.loadList(1)
    },
    editCancle() {
      let _this = this
      _this.dialogProblem = false
    },
    deleteProblem(id) {
      let _this = this
      if (confirm('您确定要删除此问题吗？') === true) {
        _this.$ajax
          .get(process.env.VUE_APP_SERVER + '/wechat/wx/delePro/' + id)
          .then(response => {
            if (response.data.code === '0') {
              _this.$swal(response.data.data)
              _this.loadList(1)
            } else {
              _this.$swal(response.data.msg)
              _this.loadList(1)
            }
          })
          .catch(err => {
            _this.$swal(err + '网络异常！')
            _this.loadList(1)
          })
      }
    },
    //编辑问题
    editProblem(id) {
      let _this = this
      _this.dialogProblem = true
      _this.$ajax
        .get(process.env.VUE_APP_SERVER + '/wechat/wx/queryProblemById/' + id)
        .then(response => {
          if (response.data.code === '0') {
            _this.problemInfo = response.data.data
          } else {
            _this.$swal(response.data.msg)
          }
        })
        .catch(err => {
          _this.$swal(err + '网络异常！')
        })
    },
    editProblemd() {
      let _this = this
      _this.$ajax
        .post(process.env.VUE_APP_SERVER + '/wechat/wx/changeProblemById', {
          title: _this.problemInfo.title,
          content: _this.problemInfo.content,
          id: _this.problemInfo.id
        })
        .then(res => {
          if (res.data.code === '0') {
            _this.$notify.success(res.data.data)
            _this.dialogProblem = false
            _this.loadList(1)
          } else {
            _this.$notify.error(res.data.msg)
            _this.dialogProblem = false
            _this.loadList(1)
          }
        })
    },
    addProblem() {
      let _this = this
      if (_this.$check.checkIsNull(_this.title)) {
        _this.$notify.error('请输入标题')
        return false
      }
      if (_this.$check.checkIsNull(_this.content)) {
        _this.$notify.error('请输入内容')
        return false
      }
      //_this.content =document.querySelector('.editor').children[0].innerHTML
      _this.$ajax
        .post(process.env.VUE_APP_SERVER + '/wechat/wx/addProblem', {
          title: _this.title,
          content: _this.content
        })
        .then(res => {
          if (res.data.code === '0') {
            _this.$notify.success(res.data.data)
            _this.dialogFormVisible = false
            _this.loadList(1)
          } else {
            _this.$notify.error(res.data.msg)
            _this.dialogFormVisible = false
            _this.loadList(1)
          }
        })
    },
    loadList(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.$ajax
        .get(process.env.VUE_APP_SERVER + '/wechat/wx/queryProblemList', {
          params: {
            current: page,
            size: _this.$refs.pagination.size
          }
        })
        .then(response => {
          console.log('111' + JSON.stringify(response))
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    }
  }
}
</script>

<style scoped>
/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
/* --------------------------弹窗样式------------------------------ */
/*标题样式*/
/deep/.class_dialog_hospital .el-dialog__title {
  font-size: 15px;
  margin-left: 15px;
}

/*头区样式*/
/deep/.class_dialog_hospital .el-dialog__header {
  height: 50px;
  background: #e6e6e6;
  padding: 15px 0 4px 10px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}

/*头区退出按钮样式*/
/deep/.class_dialog_hospital .el-dialog__headerbtn {
  top: 14px;
  right: 20px;
  font-size: 16px;
}

/*对话框区*/
/deep/.class_dialog_hospital .el-dialog {
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 4px #e6e6e6;
  border-radius: 9px;
  padding: 0;
}

/*内容区*/
/deep/.class_dialog_hospital .el-dialog__body {
  padding: 0;
  padding-top: 20px;
  margin: 0px 20px;
}

/*脚区*/
/deep/.class_dialog_hospital .el-dialog__footer {
  border-top: 2px solid #e8eaec;
  padding: 16px;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
</style>
